export function creditReducer(state = {
    INFOS:{
        creditSMS:0,
        creditAmount:0,
        creditCurrency:"",
    },
    LIST:[],
},{
    type,
    payload
}){
    switch(type){
        case "GET_CREDIT":
            let list = Object.assign({}, state)
            list.INFOS = payload
            return list;
        
        case "GET_CREDIT_LIST":
            list = Object.assign({}, state)
            list.LIST = payload
            return list;
        
        default:
            return state;
    }
}